import Currency from './currency';
import namespace from '../../upi/namespace';
import ProductCatalogService from '@services/ProductCatalogService';

var app = namespace( 'apps.productpage' );

var Sku = Currency.extend( {

    initialize: async function () {

        var sku = this.get( 'id' ),
            pricing = app.product.get( 'pricing' ),
            stock = app.product.get( 'stock' ),

            hasStock = typeof stock !== 'undefined' && typeof stock[sku] !== 'undefined',
            hasPricing = typeof pricing !== 'undefined',
            hasCustomerPrice = hasPricing && typeof pricing[sku] !== 'undefined';

        // normalize cached sku data on the Sku model
        if ( sku !== 'noop' ) {
            const skuDetail = await this.getCatalogDetail();

            if(skuDetail) {
                this.set( 'maxQuantity', skuDetail.maxQuantity );
            }

            this.set( 'inStock', hasStock
                ? stock[sku].inStock
                : true );

            this.set( 'expectedShipDate', hasStock
                ? stock[sku].expectedShipDate
                : '' );
            this.set( 'isNew', hasStock
                ? stock[sku].isNew
                : false );

            this.set( 'customerPrice', hasCustomerPrice
                ? pricing[sku].customerPrice
                : null );
            this.set( 'quantityBreaks', hasCustomerPrice
                ? pricing[sku].quantityBreaks
                : null );
        }
    },

    defaults: {
        'id': 'noop',
        'groupId': null,
        'itemName': '',
        'optionName': '',
        'kitContents': [],
        'shelfLife': [],
        'options': [],
        'currencyCode': 'US',
        'currencyCountry': 'USD',
        'customerPrice': null,
        'salePrice': null,
        // 'priceBreakdown': [],
        'quantityBreaks': [],
        'maxQuantity': null,
        'images': [],
        'unitSize': '',
        'isOrderable': true,
        'isWebOrderable': true,
        'inStock': false,
        'isNew': false,
        'isCustomPrintable': false,
        'isFormulary': false,
        'selected': false
    },

    getCatalogDetail: function () {
        return ProductCatalogService.getDetail( this.get( 'id' ) );
    },

    select: function ( isSelected ) {
        if ( isSelected && this.get( 'id' ) !== 'noop' ) {
            app.mediator.trigger( 'update:route', this );
        }

        this.set( 'selected', !!isSelected );
    },

    hasPriceRestrictions: function () {
        return this.get( 'customerPrice' ) === -1;
    },

    getProductName: function () {
        return (this.get( 'itemName' ) + ' ' + this.getOptionName()).trim();
    },

    getOptionName: function () {
        var options = _.values( this.get( 'options' ) ),
            optionName = [];

        _.each( options, function ( option ) {
            optionName.push( app.optionDetailList.findWhere( {id: option} ).get( 'longName' ) );
        } );

        return optionName.join( ', ' );
    },

    getPromotions: function () {
        let sku = this;
        var promotions = app.promotionList.filter( function ( promo ) {
            return promo.get( 'skus' ).indexOf( sku.id ) > -1;
        }, this );

        return promotions;
    },

    getPromotion: function () {
        // get first available promo from promoList
        return this.getPromotions()[0] || null;
    },

    serializePriceBreaks: function () {
        var results = [],
            customerPrice = this.get( 'customerPrice' ),
            quantityBreaks = this.get( 'quantityBreaks' );

        // append CustomerPrice as default breakpoint
        results.push( {quantity: 0, price: customerPrice} );

        // only provide price break data if customerPrice is available
        if ( customerPrice && Array.isArray( quantityBreaks ) ) {
            results = results.concat( quantityBreaks.filter( item => item.price <= customerPrice ) );
        }

        return results;
    }

} );

export default Sku;
